import(/* webpackMode: "eager" */ "/workspace/app/(chat)/layout.tsx");
